(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bal-blog-promo-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bal-blog-promo')) {
    customElements.define('bal-blog-promo', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.key = 'bal_blog_promo_seen_v1';
        this.editor = Boolean(window.Shopify?.designMode);
        this.remaining = Math.max(0, Number(this.dataset.delay) || 15) * 1000;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelectorAll('[data-promo-close]').forEach(button => {
          button.addEventListener('click', () => this.close('button'), options);
        });
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.close('escape');
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const controls = this.dialog.querySelectorAll('a[href], button:not([disabled])');
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close('backdrop');
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('bal-blog-promo-lock');
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        }, options);
        this.querySelectorAll('[data-promo-banner]').forEach(link => {
          link.addEventListener('click', () => {
            this.track('click', { banner: link.dataset.promoBanner, destination: link.getAttribute('href') });
            this.close();
          }, options);
        });
        if (this.editor) {
          this.querySelector('[data-promo-preview]')?.addEventListener('click', () => this.open(), options);
          document.addEventListener('shopify:section:select', event => {
            if (event.detail.sectionId === this.dataset.sectionId && this.dataset.preview === 'true') this.open();
          }, options);
          if (this.dataset.preview === 'true') this.open();
          return;
        }
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        window.addEventListener('scroll', () => {
          if (!this.scrollReached && this.scrollReady()) {
            this.scrollReached = true;
            this.schedule();
          }
        }, { ...options, passive: true });
        window.addEventListener('pageshow', () => this.schedule(), options);
        window.addEventListener('pagehide', () => {
          this.pause();
          this.close();
        }, options);
        this.schedule();
      }

      disconnectedCallback() {
        this.pause();
        this.close();
        this.controller?.abort();
      }

      seen() {
        if (this.dataset.frequency === 'page') return Boolean(this.pageSeen);
        try {
          if (document.cookie.split(';').some(item => item.trim() === `${this.key}=1`)) return true;
        } catch (_) {}
        try { return sessionStorage.getItem(this.key) === '1'; } catch (_) { return false; }
      }

      remember() {
        if (this.dataset.frequency === 'page') {
          this.pageSeen = true;
          return true;
        }
        try { document.cookie = `${this.key}=1; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`; } catch (_) {}
        try { sessionStorage.setItem(this.key, '1'); } catch (_) {}
        return this.seen();
      }

      pause() {
        if (this.started != null) this.remaining = Math.max(0, this.remaining - (performance.now() - this.started));
        this.started = null;
        clearTimeout(this.timer);
      }

      schedule() {
        this.pause();
        if (this.editor || this.seen() || document.hidden || !this.isConnected) return;
        if (this.dataset.mobile === 'false' && window.matchMedia('(max-width: 749px)').matches) return;
        this.started = performance.now();
        this.timer = setTimeout(() => {
          this.pause();
          if (document.hidden || this.seen()) return;
          if (!this.scrollReady()) return;
          if (this.blocked()) {
            this.timer = setTimeout(() => this.schedule(), 1000);
            return;
          }
          this.open();
        }, this.remaining);
      }

      scrollReady() {
        if (this.dataset.trigger !== 'scroll' || this.scrollReached) return true;
        const screens = Math.max(1, Number(this.dataset.scrollScreens) || 2);
        const availableScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        return window.scrollY >= Math.min(window.innerHeight * screens, availableScroll);
      }

      blocked() {
        if (document.fullscreenElement) return true;
        if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return true;
        return [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], cart-drawer.active, menu-drawer details[open], details-modal details[open], #shopify-pc__banner')]
          .some(element => {
            if (element === this.dialog || !element.getClientRects().length || element.closest('details:not([open]), [hidden], [aria-hidden="true"]')) return false;
            const style = getComputedStyle(element);
            return style.visibility !== 'hidden' && style.opacity !== '0';
          });
      }

      open() {
        if (this.dialog.open || (!this.editor && (this.seen() || document.hidden))) return;
        this.previousFocus = document.activeElement;
        try { this.dialog.showModal(); } catch (_) { return; }
        if (!this.editor && !this.remember()) {
          this.dialog.close();
          return;
        }
        document.documentElement.classList.add('bal-blog-promo-lock');
        this.querySelector('[data-promo-close]')?.focus({ preventScroll: true });
        this.track('view');
      }

      close(reason) {
        if (!this.dialog?.open) return;
        if (reason) this.track('dismiss', { method: reason });
        this.dialog.close();
        document.documentElement.classList.remove('bal-blog-promo-lock');
      }

      track(action, details = {}) {
        if (this.editor || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
        const payload = { event: `blog_promo_${action}`, section_id: this.dataset.sectionId, ...details };
        if (typeof window.gtag === 'function') window.gtag('event', payload.event, { section_id: payload.section_id, ...details });
        else if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
